import React from "react";
import { TextField, SxProps, Theme, TextFieldProps } from "@mui/material";

interface FormTextFieldProps {
  id: string;
  label: string | React.ReactNode;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
  variant?: "outlined" | "standard";
  required?: boolean;
  className?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
  type?: string;
  placeholder?: string;
  disabled?: boolean; // Add this line
  /** Extra props forwarded to MUI TextField */
  InputProps?: TextFieldProps["InputProps"];
  InputLabelProps?: TextFieldProps["InputLabelProps"];
  /** Props for the input element */
  inputProps?: TextFieldProps["inputProps"];
}

const FormTextField: React.FC<FormTextFieldProps> = ({
  id,
  label,
  value,
  onChange,
  error,
  helperText,
  variant = "outlined",
  required = false,
  className = "inputs-field",
  inputRef,
  onKeyDown,
  onBlur,
  sx,
  type,
  placeholder,
  disabled = false, // Add this line with default value
  InputProps,
  InputLabelProps,
  inputProps,
}) => {
  const renderLabel = (
    <span>
      {label} {required && <span style={{ color: "red" }}>*</span>}
    </span>
  );

  return (
    <TextField
      id={id}
      label={renderLabel}
      variant={variant}
      className={className}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      fullWidth
      inputRef={inputRef}
      onKeyDown={onKeyDown}
      sx={sx}
      type={type}
      placeholder={placeholder}
      disabled={disabled} // Add this line
      InputProps={InputProps}
      InputLabelProps={InputLabelProps}
      inputProps={inputProps}
    />
  );
};

export default FormTextField;